export const BaseURL = process.env.REACT_APP_API_BASE_URL;
export const ContestToken = 'f828833e3e73756e3168ba18a0a946d8a08e3f0224755235a85d021f315cf557';

export const isMock = () => {
    return (window as any)?.NaviScripts?.isBuild;
};
